import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import ErrorBoundary from './components/ErrorBoundary';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Global Error Suppression for MetaMask/Extension errors
const suppressErrors = (message) => {
    if (message && (
        message.includes('MetaMask') ||
        message.includes('chrome-extension') ||
        message.includes('Failed to connect')
    )) {
        return true; // Suppress error
    }
    return false;
};

window.addEventListener('error', (e) => {
    if (suppressErrors(e.message)) {
        e.preventDefault();
        e.stopPropagation();
    }
});

window.addEventListener('unhandledrejection', (e) => {
    if (suppressErrors(e.reason?.message)) {
        e.preventDefault();
        e.stopPropagation();
    }
});

// Aggressive suppression via window.onerror
window.onerror = function (msg, url, lineNo, columnNo, error) {
    if (suppressErrors(msg) || suppressErrors(error?.message)) {
        return true; // Prevents the firing of the default event handler
    }
    return false;
};

// Override console.error to prevent React Error Overlay from showing these
const originalConsoleError = console.error;
console.error = (...args) => {
    if (
        typeof args[0] === 'string' &&
        (args[0].includes('MetaMask') || args[0].includes('chrome-extension'))
    ) {
        return;
    }
    originalConsoleError(...args);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <ErrorBoundary>
            <App />
        </ErrorBoundary>
    </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();